import * as React from "react";
export function SvgDataCatalogLineageVirtualConnectionActive(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <path
        d="M19 4a1 1 0 0 1 1 1v3a.995.995 0 0 1-.134.501A.982.982 0 0 1 20 9v3a.995.995 0 0 1-.134.501A.982.982 0 0 1 20 13v3a1 1 0 0 1-1 1h-7v1.086c.436.154.778.502.924.941l-.01-.028L18 19v1h-5.086l.008-.022a1.5 1.5 0 0 1-2.796.124l-.04-.101L6 20v-1l4.086-.001-.01.028c.146-.439.489-.788.924-.942V17H5a1 1 0 0 1-1-1v-3c0-.182.049-.353.134-.5A.993.993 0 0 1 4 12V9c0-.182.049-.353.134-.5A.993.993 0 0 1 4 8V5a1 1 0 0 1 1-1h14zm-7.5 15a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm5.5-6H5v3h14v-3h-1v1h-1v-1zm0-4H5v3h14V9h-1v1h-1V9zm0-4H5v3h14V5h-1v1h-1V5z"
        fill="#333"
        fillRule="evenodd"
      />
    </svg>
  );
}
